<div *ngIf="!!videoUrl && !!assortment && !!newsList" class="row">
  <div class="col-12 mb-4">
    <div class="startpage-video-container">
      <video
        playsinline
        autoplay
        [muted]="'muted'"
        loop
        class="startpage-video"
        [poster]="backgroundImage"
      >
        <source [src]="videoUrl" type="video/mp4" />
      </video>
    </div>
  </div>

  <div class="col-12 col-md-6 col-lg-7 mb-4 mb-md-0">
    <h2>{{ assortment?.name | translate }}</h2>
    <div class="row">
      <div *ngFor="let child of assortment.children" class="col-6 mb-2">
        <div class="card card-assortment-tree h-100 card-border-top">
          <a [routerLink]="['/articles/', child.id]" class="border-0">
            <img
              *ngIf="child.extra.images && child.extra.images[0] as image; else noimage"
              class="card-img-top img-fluid mx-auto d-block"
              src="https://cdn1.gung.io/fit-in/350x350/filters:fill(white):background_color(white):etag({{
                image.s3ETag
              }}):format(jpeg)/{{ image.s3Uri }}"
              alt="{{ image.description }}"
            />
            <ng-template #noimage>
              <img
                class="card-img-top img-fluid w-100"
                src="https://cdn1.gung.io/fit-in/300x300/images/no-image.jpg"
                alt="NO IMAGE"
                class="img-fluid mx-auto d-block"
              />
            </ng-template>
            <div class="card-body d-flex">
              <div class="card-title align-self-end w-100">
                <a
                  [routerLinkActive]="'active-assortment'"
                  [routerLink]="['/articles/', child.id]"
                  class="d-flex align-items-center justify-content-between text-break border-0"
                >
                  <span>{{ child.name }}</span>
                  <i class="fa fa-angle-right align-self-end" aria-hidden="true" style="font-size: x-large"></i>
                </a>
              </div>
              <p class="card-text"></p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-6 col-lg-4 offset-lg-1">
    <h2>{{ 'NEWS' | translate }}</h2>
    <div class="row">
      <div *ngFor="let news of newsList" class="col-6 mb-2">
        <div class="card-body h-100 border d-flex flex-column">
          <img
            class="card-img-top"
            *ngIf="news.extra && news.extra.cover as image; else noimage"
            src="{{ image }}"
            alt=""
          />
          <ng-template #noimage>
            <img
              [src]="'images/no-image.jpg' | gungImageUrl"
              alt="NO IMAGE"
              class="card-img-top"
            />
          </ng-template>
          <div class="card-body d-flex flex-column justify-content-end">
            <h5 class="card-title">{{ news.i18n?.[currentLang]?.name || news.name }}</h5>
            <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> -->
            <a [routerLink]="['/news/', news.id]" class="btn btn-primary" translate>GO_TO_NEWS</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
